const utils = {
  ency: '-----BEGIN PUBLIC KEY-----MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQDLA1YCIUEdGEV9HuEanBpJo1Do8EJawe9FSYgiAnvXBo80VrSK8/RXYJ95cUb93WnOm5sDfUIvbHHkgeYyQ50CgJ6TsIp7PX9pk5ol+cXRZ8AjMHs1WLVInZfyxRlKTfuQOeZPuV7CXDVrAJ/TU+X3eANjerhwVu7q98FYtBSpzwIDAQAB-----END PUBLIC KEY-----',

  // 千分号，并保留相对应的小数位数
  toThousands: function (num = 0, decimal = 2) {
    const formatter = new Intl.NumberFormat(undefined, {
      minimumFractionDigits: decimal,
      maximumFractionDigits: decimal,
    })
    const formattedNumber = formatter.format(num)
    return formattedNumber
  },
}

export default utils
